import { render, staticRenderFns } from "./addOrEditBrochure.vue?vue&type=template&id=c6fd2f0a&scoped=true"
import script from "./addOrEditBrochure.vue?vue&type=script&lang=js"
export * from "./addOrEditBrochure.vue?vue&type=script&lang=js"
import style0 from "./addOrEditBrochure.vue?vue&type=style&index=0&id=c6fd2f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fd2f0a",
  null
  
)

export default component.exports